import axios from "axios";
import { getApiBaseUrl } from "src/utils/apiBaseUrl";
import { delToken } from "../utils/storage";

const client = axios.create({
  baseURL: getApiBaseUrl(),
});

const addCacheBuster = (url) => {
  if (!url || url.includes("_ts=")) {
    return url;
  }
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}_ts=${Date.now()}`;
};

client.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (
    method === "get" &&
    typeof config.url === "string" &&
    (config.url.includes("localhost") || config.url.includes("127.0.0.1"))
  ) {
    config.url = addCacheBuster(config.url);
  }

  config.headers = {
    ...config.headers,
  };

  return config;
});

const adapter = function (options) {
  function onSuccess(response) {
    return response.data;
  }

  function onError(error) {
    if (error?.response?.status === 401) {
      delToken();
      window.location.reload();
      return Promise.reject(error.response || error.message);
    }
    return Promise.reject(error.response || error.message);
  }
  return client(options).then(onSuccess).catch(onError);
};

export default adapter;
